import { render, staticRenderFns } from "./citationDetails.vue?vue&type=template&id=683ba908&scoped=true&"
import script from "./citationDetails.vue?vue&type=script&lang=js&"
export * from "./citationDetails.vue?vue&type=script&lang=js&"
import style0 from "./citationDetails.vue?vue&type=style&index=0&id=683ba908&prod&scoped=true&lang=scss&"
import style1 from "./citationDetails.vue?vue&type=style&index=1&id=683ba908&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683ba908",
  null
  
)

export default component.exports